import { render } from "./ourTeam.vue?vue&type=template&id=1d846366"
import script from "./ourTeam.vue?vue&type=script&lang=js"
export * from "./ourTeam.vue?vue&type=script&lang=js"

import "./ourTeam.vue?vue&type=style&index=0&id=1d846366&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__